// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"MacroCell-primaryButton-11ozKB","macroWarningHint":"MacroCell-macroWarningHint-3KxLbg"};